//@flow

import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import slugify from '@sindresorhus/slugify';

type Props = {
  titles: Array<String>,
  forMobile?: boolean,
  urlPrefix?: string,
};

/**
 *
 * @param {String} str
 * @example "When to go to EBC?" => "#when-to-go-to-ebc?"
 * Creates hash links from a string
 *
 */

function createHashLink(str) {
  const lowercasedHyphenedStr = str
    .split(/[.?\s]+/)
    .filter(x => !!x)
    .map(t => t.toLowerCase())
    .join('-');

  return `#${lowercasedHyphenedStr}`;
}

const TOC = ({ titles, forMobile = false, urlPrefix }: Props) => (
  <div className={`side-bar ${forMobile ? 'd-block d-md-none' : ''}`}>
    <div className="sidebar-title">Table of Content</div>
    <ul>
      {titles.map((title: string) => (
        <li key={title}>
          <span className="title">
            {urlPrefix ? (
              <Link to={`${urlPrefix}/${slugify(title)}`}>{title}</Link>
            ) : (
              <a href={createHashLink(title)}>{title}</a>
            )}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

export default withRouter(TOC);



// WEBPACK FOOTER //
// ./src/components/TOC/TOC.js